module.exports = __webpack_public_path__ + "img/Marshall-Islands.4621d623.png";